var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('buttonlist',{ref:"SetBtn",on:{"help":_vm.help}}),_c('div',[_c('el-button',{attrs:{"type":"primary","disabled":!_vm.btn.exc},on:{"click":_vm.excute}},[_vm._v(_vm._s(_vm.$t('getapi[440]')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }